import { useTranslation } from "react-i18next";import React, { useEffect, useState } from 'react';
import { useStore } from 'react-redux';
import { setHeaderContent } from 'state/actions';
import { Link } from 'react-router-dom';

const DELAY_TIME = 1500;

const PageNotFound = (props) => {
  const { t } = useTranslation();
  const { dispatch } = useStore();
  const [isContentVisible, setIsContentVisible] = useState(false);

  useEffect(() => {
    dispatch(setHeaderContent([]));
    const timer = setTimeout(() => {
      setIsContentVisible(true);
    }, DELAY_TIME);

    return () => clearTimeout(timer);
  }, []);

  if (!isContentVisible) return null;

  return (
    <main className="text-center my-5">
            <h2 className="text-color-changeable mb-5">{props.title ? props.title : "Error 404 - Not Found!"}</h2>
            <Link to="/" className="btn btn-back h-42 px-12 text-decoration-none">{t("Go Home")}</Link>
        </main>);

};

export default PageNotFound;